import axios from 'axios';
import humps from 'humps';
import qs from 'qs';
import { isNil } from 'ramda';

const getAppSignature = () => {
  const root = document.getElementById('currency_converter_dashboard_root');
  if (isNil(root)) {
    return '';
  }

  const params = JSON.parse(root.dataset.params);
  const signature = params.signature;
  if (isNil(signature)) {
    return '';
  }

  return signature;
};

axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common.Accept = 'application/json';
axios.defaults.headers.common['X-Ecwid-Signature'] = getAppSignature();

const get = async (url, params, opts = {}) => {
  const formattedParams = humps.decamelizeKeys(params);
  const { data } = await axios.get(url, {
    params: formattedParams,
    paramsSerializer: (parameters) =>
      qs.stringify(parameters, { encode: false }),
  });
  if (opts.camelizeResponse) {
    return humps.camelizeKeys(data);
  }
  return data;
};

const post = async (url, body) => {
  const { data } = await axios.post(url, body);
  return data;
};

const put = async (url, body, params) => {
  const { data } = await axios.put(url, body, { params });
  return data;
};

const destroy = async (url, params) => {
  const { data } = await axios.delete(url, { params });

  return data;
};

export default { get, post, put, destroy };
